import {
    AuthenticatedUser,
    useSwapOrgAuthenticationMutation,
} from "@biggeo/bg-server-lib/studio";
import { Success, isSuccess } from "@vividtheory/remotedata";
import { useDispatch } from "react-redux";

import { AccountMenu } from "../../components/AccountMenu";
import { useErrorToast } from "../../toaster/containers/redux/hooks";
import { useDatascapeOrganizations } from "../../user/redux/hooks";
import { userActions } from "../../user/redux/model";

export const AccountMenuContainer = ({
    authUser,
}: { readonly authUser: AuthenticatedUser }) => {
    const dispatch = useDispatch();
    const errorToast = useErrorToast();

    const organizationsRD = useDatascapeOrganizations();

    const {
        executeMutation: swapOrgAuthenticationMutation,
        mutationReturn: [_c, { loading }],
    } = useSwapOrgAuthenticationMutation();

    const swapOrg = (input: {
        organizationId: string;
        name: string;
    }) => {
        swapOrgAuthenticationMutation({
            variables: {
                organizationId: input.organizationId,
            },
            onCompleted: (result) => {
                dispatch(
                    userActions.setUserRemoteData(
                        new Success(result.swapOrgAuthentication)
                    )
                );
            },
            onError: (error) => {
                errorToast(
                    `Error switching to Organization ${input.name}: ${error.message}`
                );
            },
        });
    };

    return (
        <AccountMenu
            user={authUser}
            organizations={
                isSuccess(organizationsRD) ? organizationsRD.data : []
            }
            swapOrgAuth={swapOrg}
            swapOrgAuthLoading={loading}
        />
    );
};
